import React, { useState,useEffect } from 'react';
import styles from './changePassword.module.scss';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import { CustomTextFieldPass } from '../shared/textFieldPass';
import { CustomButton } from '../shared/customButton';
import { CustomAlertBox } from '../shared/customAlertBox';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import { changePassword } from '../../services/util/userSettings';

const ChangePassword = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let history = useNavigate();

    const backClicked = () => {
        history.goBack();
    }

    const schema = yup.object({
        oldPassword: yup.string().min(8, 'Minimum length is 8 characters').required('Old Password Required'),
        newPassword: yup.string().min(8, 'Minimum length is 8 characters').required('New Password Required'),
    });

    const formFocus = () => {
        setShow(false)
    }

    const onSubmit = async (values) => {
        setLoading(true)
        let response = await changePassword(values.oldPassword, values.newPassword);

        if (response.success === true) {
            setLoading(false)
            history('/signin')
        } else {
            setMessage(response.msg)
            setLoading(false)
            setShow(true)
        }
    }

    useEffect(() => {
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Change Password | HireTrace</title>
            </Helmet>
            <Row className={styles.changePasswordBackground}>
                <Container>
                    <Row>
                        <Col xs={{ span: 6, offset: 3 }} >
                            <div className={styles.changePasswordBox}>
                                <Container className={styles.innerBoxContainer}>
                                    <Col xs={{ span: 2, offset: 10 }} sm={{ span: 1, offset: 11 }}>
                                        <i className="fas fa-times fa-2x" onClick={() => backClicked()}></i>
                                    </Col>
                                    <Col sm={{ span: 10, offset: 1 }}>
                                        <a href="/" target="_blank" rel="noreferrer">
                                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/companylogo.png`} rounded fluid className={styles.companyLogo} />
                                        </a>
                                    </Col>
                                    <Row>
                                        <Col sm={12}>
                                            <h3 className={styles.boxTopic}>Change Password ?</h3>
                                        </Col>
                                    </Row>
                                    {show === true &&
                                        <Row>
                                            <Col sm={12} className={styles.alertColumn}>
                                                {show === true ? (<CustomAlertBox alertBodyText={message} alertType='dangerAlert'/>) : ''}
                                            </Col>
                                        </Row>
                                    }
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values) => onSubmit(values)}
                                        initialValues={{}}>
                                        {({
                                            errors,
                                            handleChange,
                                            handleSubmit,
                                            submitCount
                                        }) => (
                                            <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                <div className={styles.formDivRow}>
                                                    <CustomTextFieldPass
                                                        label="Current Password *"
                                                        classLabel="defaultLabel"
                                                        controlId="oldPassword"
                                                        type="password"
                                                        name="oldPassword"
                                                        classType="defaultTextBox"
                                                        handleOnChange={handleChange}
                                                        errorMessage={errors.oldPassword}
                                                        isInvalid={submitCount > 0 && !!errors.oldPassword}
                                                    />
                                                </div>
                                                <div className={styles.formDivRow}>
                                                    <CustomTextFieldPass
                                                        label="New Password *"
                                                        classLabel="defaultLabel"
                                                        controlId="newPassword"
                                                        type="password"
                                                        name="newPassword"
                                                        classType="defaultTextBox"
                                                        handleOnChange={handleChange}
                                                        errorMessage={errors.newPassword}
                                                        isInvalid={submitCount > 0 && !!errors.newPassword}
                                                    />
                                                </div>
                                                <div className={styles.formDivRow}>

                                                    {<CustomButton
                                                        buttonType="submit"
                                                        label="Change Password"
                                                        type="primaryBtn"
                                                        disabled={isLoading === true ? true : false}
                                                        backicon=
                                                        {isLoading === true ?
                                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                            : ''
                                                        }

                                                    />}

                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </Container>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
        </div>
    )
}

export default ChangePassword;
